'use client';

import { LinkButton } from 'BomdisoftComponents/buttons/link';
import { pausedCardStyles as s } from 'BomdisoftComponents/paused-card/classes';
import 'BomdisoftComponents/paused-card/styles.css';
import { type ReactNode, useId } from 'react';

export type PausedCardProps = {
  body: ReactNode;
  pay: { href: string; label: string } | null;
  testId: string;
  title: string;
  whoCanPay: string;
};

export const PausedCard = ({ body, pay, testId, title, whoCanPay }: PausedCardProps): ReactNode => {
  const titleId = useId();
  return (
    <div className={s.host} data-testid={testId}>
      <section aria-labelledby={titleId} className={s.card}>
        <h1 className={s.title} data-testid={`${testId}-title`} id={titleId}>
          {title}
        </h1>
        {body === null ? null : (
          <p className={s.body} data-testid={`${testId}-body`}>
            {body}
          </p>
        )}
        {pay === null ? (
          <p className={s.who} data-testid={`${testId}-who`}>
            {whoCanPay}
          </p>
        ) : (
          <LinkButton className={s.pay} data-testid={`${testId}-pay`} external href={pay.href} variant='contained'>
            {pay.label}
          </LinkButton>
        )}
      </section>
    </div>
  );
};
